import {
    Alert,
    Col,
    Collapse,
    message,
    PageHeader,
    Row,
    Spin,
    Select,
    Space,
    Table,
    Tabs,
    Tag,
    Tooltip,
} from "antd";
import axios from "axios";
import React, { Component } from "react";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { connect } from "react-redux";
// import balanceGeneralPdf from "../../../../Pdf/balanceGeneralPdf";
import {
    SelectItem,
    Form,
    FormItem,
    TableItem,
    dineroDisabledMask,
    ButtonItem,
    ErrorItem,
    RangePickerItem,
    DatePickerItem,
    round2Decimals
} from "../../../../Components/Items";
import { FileExcelOutlined, FilePdfOutlined, FileTextOutlined } from "@ant-design/icons";
import * as XLSX from "xlsx";
import * as XLSXStyle from "xlsx-js-style";
import moment from "moment";
import "moment/locale/es";
import reporteDIOTPdf from "../../../../Pdf/reporteDIOTPdf";
import localeTable from "../../../../Components/localeTable";
import ModalAjusteDiot from "../../../../Components/ModalAjusteDiot";
import armarTxtDiot from "./armarTxtDiot";
moment.locale("es");
pdfMake.vfs = pdfFonts.pdfMake.vfs;

const { Option } = Select;
const { TabPane } = Tabs;
const { Panel } = Collapse;

// --- Papel de trabajo: desglose por factura ---

const sumaCampo = (filas, campo) =>
    (filas || []).reduce((acc, r) => acc + (Number(r[campo]) || 0), 0);

const money = (v) => dineroDisabledMask(v || 0);

const rControl = (v) => (
    <span style={{ fontWeight: 700 }}>{dineroDisabledMask(v || 0)}</span>
);

// noSuma marca las columnas alineadas a la derecha que NO se totalizan: el total
// de la factura se repetiria por cada pago parcial, y la proporcion no es un importe.
// Los 12 campos que el motor puebla mas las 3 columnas de control: es exactamente lo
// que el backend manda en `original` de un renglon ajustado, y por lo tanto lo unico
// que se puede comparar antes/despues.
const CAMPOS_COMPARABLES_AJUSTE = [
    "monto12", "monto13", "ivaCampo22", "ivaNCampo37",
    "monto8", "monto9", "ivaCampo18", "ivaNCampo29",
    "monto51", "monto50", "monto52", "ivaRetenido48",
    "valorActos", "ivaAcreditable", "ivaNoAcreditable",
];

const COLS_PAPEL = [
    {
        // Va primera y sin align para que el Excel la herede y no intente sumarla.
        title: "Ajuste", dataIndex: "ajustado", key: "ajustado", width: 90,
        render: (v, r) => {
            if (r.errorCalculo && !v) return <Tag color="red">Error</Tag>;
            if (!v) return null;
            return (
                <Tooltip title={r.ajusteMotivo || "Sin motivo capturado"}>
                    <Tag color="gold">Ajustado</Tag>
                </Tooltip>
            );
        },
    },
    {
        title: "Fecha", dataIndex: "fecha", key: "fecha", width: 100,
        render: (v) => (v ? moment(v).format("DD/MM/YYYY") : "—"),
    },
    { title: "Tipo", dataIndex: "tipoMovimiento", key: "tipoMovimiento", width: 120 },
    { title: "Proveedor", dataIndex: "nombreProveedor", key: "nombreProveedor", width: 200, ellipsis: true },
    { title: "RFC", dataIndex: "rfc", key: "rfc", width: 130 },
    { title: "Documento", dataIndex: "documento", key: "documento", width: 130, ellipsis: true },
    {
        title: "UUID", dataIndex: "uuid", key: "uuid", width: 110,
        render: (v) => (v ? v.substring(0, 8) + "…" : "—"),
    },
    { title: "Descripción", dataIndex: "descripcion", key: "descripcion", width: 200, ellipsis: true },
    {
        title: "Total Doc.", dataIndex: "totalDocumento", key: "totalDocumento", width: 120,
        align: "right", noSuma: true,
        render: (v) => (v == null ? "—" : money(v)),
    },
    {
        title: "Monto Pagado", dataIndex: "montoPagado", key: "montoPagado", width: 120,
        align: "right",
        render: (v) => (v == null ? "—" : money(v)),
    },
    {
        title: "% Factura", dataIndex: "proporcion", key: "proporcion", width: 95,
        align: "right", noSuma: true,
        render: (v) => (v == null ? "—" : `${(v * 100).toFixed(2)}%`),
    },
    { title: "Base 8%", dataIndex: "monto8", key: "monto8", width: 115, align: "right", render: money },
    { title: "Dev. 8%", dataIndex: "monto9", key: "monto9", width: 115, align: "right", render: money },
    { title: "IVA 8% Acred.", dataIndex: "ivaCampo18", key: "ivaCampo18", width: 125, align: "right", render: money },
    { title: "IVA 8% No Acred.", dataIndex: "ivaNCampo29", key: "ivaNCampo29", width: 135, align: "right", render: money },
    { title: "Base 16%", dataIndex: "monto12", key: "monto12", width: 115, align: "right", render: money },
    { title: "Dev. 16%", dataIndex: "monto13", key: "monto13", width: 115, align: "right", render: money },
    { title: "IVA 16% Acred.", dataIndex: "ivaCampo22", key: "ivaCampo22", width: 130, align: "right", render: money },
    { title: "IVA 16% No Acred.", dataIndex: "ivaNCampo37", key: "ivaNCampo37", width: 140, align: "right", render: money },
    { title: "Base 0%", dataIndex: "monto51", key: "monto51", width: 115, align: "right", render: money },
    { title: "Exentos", dataIndex: "monto50", key: "monto50", width: 115, align: "right", render: money },
    { title: "No Objeto", dataIndex: "monto52", key: "monto52", width: 115, align: "right", render: money },
    { title: "IVA Retenido", dataIndex: "ivaRetenido48", key: "ivaRetenido48", width: 125, align: "right", render: money },
    { title: "Valor Actos", dataIndex: "valorActos", key: "valorActos", width: 125, align: "right", render: rControl },
    { title: "IVA Acreditable", dataIndex: "ivaAcreditable", key: "ivaAcreditable", width: 135, align: "right", render: rControl },
    { title: "IVA No Acreditable", dataIndex: "ivaNoAcreditable", key: "ivaNoAcreditable", width: 150, align: "right", render: rControl },
];

class ReporteDIOT extends Component {
    state = {
        loading: false,
        pdf: null,
        dataReporte: null,
        // Los filtros de la ultima consulta: al guardar o quitar un ajuste hay que
        // repetirla, y antes no quedaban en ningun lado.
        ultimaConsulta: null,
        modalAjusteVisible: false,
        filaAjuste: null,
    };

    atras() {
        this.props.history.goBack();
    }

    async componentDidMount() {
        this.setState({ loading: true });
        this.consultarReporteDIOT({
            tipoReporte: 1,
            fechaReporte: moment()
        });
    }

    consultarReporteDIOT(values) {
        this.setState({ loading: true, ultimaConsulta: values });
        axios
            .post(
                "reportesFiscales/reporteDIOT",
                { ...values, empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    this.setState({
                        loading: false,
                        dataReporte: res.data,
                    });
                } else if (res.data.success === 1) {
                    message.error("Ha sucedido un error y no se cargo bien el reporte");
                } else {
                    message.error("Ha sucedido un error y no se cargo bien el reporte");
                }
                this.setState({ loading: false });
            });
    }

    descargarExcel() {
        let datosDescargar = this.state.dataReporte.diot.map((valueDIOT) => {
            return {

                "Tipo Tercero": String(valueDIOT.tipoTercero || '').padStart(2, '0'),
                "Tipo Operación": String(valueDIOT.tipoOperacion || '').padStart(2, '0'),
                "RFC": valueDIOT.rfc,
                "Número de identificación fiscal": valueDIOT.idFiscal,
                "Nombre Extranjero": valueDIOT.nombreExtranjero,
                "País de residencia": valueDIOT.paisResidencia,
                "Nacionalidad": valueDIOT.nacionalidad,

                // Campos DIOT mapeados
                "Actos o actividades pagados en la (RFN)": valueDIOT.monto8,
                "Devoluciones, descuentos y bonificaciones (RFN)": valueDIOT.monto9,
                "Actos o actividades pagados en la (RFS)": valueDIOT.monto10,
                "Devoluciones, descuentos y bonificaciones (RFS)": valueDIOT.monto11,
                "Base 16%": valueDIOT.monto12,
                "Devoluciones, descuentos y bonificaciones 16%": valueDIOT.monto13,
                "Importaciones tangibles 16%": valueDIOT.monto14,
                "Devoluciones, descuentos y bonificaciones Importaciones tangibles 16%": valueDIOT.monto15,
                "Importaciones Intangibles 16%": valueDIOT.monto16,
                "Devoluciones, descuentos y bonificaciones Importaciones Intangibles 16%": valueDIOT.monto17,

                "Exclusivamente de actividades gravadas (Monto del IVA pagado acreditable en la RFN)": valueDIOT.ivaCampo18,
                "Asociado actividades por las cuales se aplicó una proporción (RFN)": valueDIOT.ivaCampo19,
                "Exclusivamente de actividades gravadas (Monto del IVA pagado acreditable en la RFS)": valueDIOT.ivaCampo20,
                "Asociado actividades por las cuales se aplicó una proporción (RFS)": valueDIOT.ivaCampo21,
                "Exclusivamente de actividades gravadas (Monto del IVA pagado acreditable a la tasa del 16%)": valueDIOT.ivaCampo22,
                "Asociado actividades por las cuales se aplicó una proporción (base 16%)": valueDIOT.ivaCampo23,
                "Exclusivamente de actividades gravadas (Monto del IVA pagado acreditable en la importación por aduana de bienes tangibles a la tasa del 16%)": valueDIOT.ivaCampo24,
                "Asociado actividades por las cuales se aplicó una proporción  (Monto del IVA pagado acreditable en la importación por aduana de bienes tangibles a la tasa del 16%)": valueDIOT.ivaCampo25,
                "Exclusivamente de actividades gravadas (Monto del IVA pagado acreditable en la importación de bienes intangibles y servicios a la tasa del 16%)": valueDIOT.ivaCampo26,
                "Asociado actividades por las cuales se aplicó una proporción (Monto del IVA pagado acreditable en la importación de bienes intangibles y servicios a la tasa del 16%)": valueDIOT.ivaCampo27,

                "Asociado a actividades por las cuales se aplicó una proporción (Monto del IVA pagado no acreditable en la RFN)": valueDIOT.ivaNCampo28,
                "Asociado a actividades que no cumple con requisitos (Monto del IVA pagado no acreditable en la RFN)": valueDIOT.ivaNCampo29,
                "Asociado a actividades exentas (Monto del IVA pagado no acreditable en la RFN)": valueDIOT.ivaNCampo30,
                "Asociado a actividades no objeto (Monto del IVA pagado no acreditable en la RFN)": valueDIOT.ivaNCampo31,
                "Asociado a actividades por las cuales se aplico una proporción (Monto del IVA pagado no acreditable en la RFS)": valueDIOT.ivaNCampo32,
                "Asociado a que no cumple con requisitos (Monto del IVA pagado no acreditable en la RFS)": valueDIOT.ivaNCampo33,
                "Asociado a actividades exentas (Monto del IVA pagado no acreditable en la RFS)": valueDIOT.ivaNCampo34,
                "Asociado a actividades no objeto (Monto del IVA pagado no acreditable en la RFS)": valueDIOT.ivaNCampo35,
                "Asociado a actividades por las cuales se aplico una proporción (Monto del IVA pagado no acreditable a la tasa del 16%)": valueDIOT.ivaNCampo36,
                "Asociado a que no cumple con requisitos (Monto del IVA pagado no acreditable a la tasa del 16%)": valueDIOT.ivaNCampo37,
                "Asociado a actividades exentas ( Monto del IVA pagado no acreditable a la tasa del 16%)": valueDIOT.ivaNCampo38,
                "Asociado a actividades no objeto (Monto del IVA pagado no acreditable a la tasa del 16%)": valueDIOT.ivaNCampo39,
                "Asociado a actividades por las cuales se aplico una proporción (Monto del IVA pagado no acreditable en la importación por aduana de bienes tangibles a la tasa del 16%)": valueDIOT.ivaNCampo40,
                "Asociado a que no cumple con requisitos (Monto del IVA pagado no acreditable en la importación por aduana de bienes tangibles a la tasa del 16%)": valueDIOT.ivaNCampo41,
                "Asociado a actividades exentas (Monto del IVA pagado no acreditable en la importación por aduana de bienes tangibles a la tasa del 16%)": valueDIOT.ivaNCampo42,
                "Asociado a actividades no objeto (Monto del IVA pagado no acreditable en la importación por aduana de bienes tangibles a la tasa del 16%)": valueDIOT.ivaNCampo43,
                "Asociado a actividades por las cuales se aplico una proporción (Monto del IVA pagado no acreditable en la importación de bienes intangibles y servicios a la tasa del 16%)": valueDIOT.ivaNCampo44,
                "Asociado a que no cumple con requisitos (Monto del IVA pagado no acreditable en la importación de bienes intangibles y servicios a la tasa del 16%)": valueDIOT.ivaNCampo45,
                "Asociado a actividades exentas (Monto del IVA pagado no acreditable en la importación de bienes intangibles y servicios a la tasa del 16%)": valueDIOT.ivaNCampo46,
                "Asociado a actividades no objeto (Monto del IVA pagado no acreditable en la importación de bienes intangibles y servicios a la tasa del 16%)": valueDIOT.ivaNCampo47,

                "IVA retenido por el contribuyente": valueDIOT.ivaRetenido48,
                "Actos o actividades pagados en la importación de bienes y servicios por los que no se pagara el IVA (Exentos)": valueDIOT.monto49,
                "EXENTOS": valueDIOT.monto50,
                "BASE 0%": valueDIOT.monto51,
                "No Objeto": valueDIOT.monto52,
                "No objeto del IVA por  no contar con establecimiento en territorio nacional": valueDIOT.monto53,
                "Manifiesto que se dio efectos fiscales a los comprobantes que amparan las operaciones realizadas": valueDIOT.campo54,
            };
        });
        const worksheet = XLSX.utils.json_to_sheet(datosDescargar);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Reporte DIOT");
        //let buffer = XLSX.write(workbook, { bookType: "xlsx", type: "buffer" });
        //XLSX.write(workbook, { bookType: "xlsx", type: "binary" });
        XLSX.writeFile(workbook, `Reporte_DIOT_${moment().locale("es").format("L")}.xlsx`);
    }

    descargarPdf() {
        pdfMake
            .createPdf(reporteDIOTPdf(this.state.dataReporte))
            .download(`Reporte_DIOT_${moment().locale("es").format("L")}`);
    }

    textoPeriodo() {
        const { tipoReporte, fechaReporte, periodo } = this.state.dataReporte || {};
        if (tipoReporte === 1 && fechaReporte) {
            return moment(fechaReporte).locale("es").format("MMMM [de] YYYY").toUpperCase();
        }
        if (periodo?.length === 2) {
            return `${moment(periodo[0]).format("DD/MM/YYYY")} — ${moment(periodo[1]).format("DD/MM/YYYY")}`;
        }
        return "";
    }

    descargarPapelTrabajo() {
        const filas = this.state.dataReporte?.papelTrabajo;
        if (!filas || filas.length === 0) {
            message.warning("No hay movimientos en el periodo");
            return;
        }

        const HEADER_COLOR = "D9D9D9";
        const TOTAL_COLOR = "E6FFFB";
        const PROVEEDOR_COLOR = "BDD7EE";
        // Formato Contabilidad: el signo de pesos queda pegado al borde izquierdo
        // de la celda y el numero al borde derecho, en vez de ir junto al numero.
        const FORMATO_CONTABILIDAD = '_-"$"* #,##0.00_-;-"$"* #,##0.00_-;_-"$"* "-"??_-;_-@_-';
        const border = {
            top: { style: "thin", color: { auto: 1 } },
            bottom: { style: "thin", color: { auto: 1 } },
            left: { style: "thin", color: { auto: 1 } },
            right: { style: "thin", color: { auto: 1 } },
        };
        const headerStyle = {
            font: { bold: true, sz: 10 },
            fill: { fgColor: { rgb: HEADER_COLOR } },
            alignment: { horizontal: "center", vertical: "center", wrapText: true },
            border,
        };
        const proveedorStyle = {
            font: { bold: true, sz: 11, color: { rgb: "FFFFFF" } },
            fill: { fgColor: { rgb: PROVEEDOR_COLOR } },
            border,
        };
        const totalStyle = {
            font: { bold: true, sz: 10 },
            fill: { fgColor: { rgb: TOTAL_COLOR } },
            alignment: { horizontal: "right" },
            numFmt: FORMATO_CONTABILIDAD,
            border,
        };
        const totalEtiquetaStyle = {
            font: { bold: true, sz: 10 },
            fill: { fgColor: { rgb: TOTAL_COLOR } },
            alignment: { horizontal: "left" },
            border,
        };
        const moneyStyle = {
            alignment: { horizontal: "right" },
            numFmt: FORMATO_CONTABILIDAD,
            border,
        };
        const textStyle = { border };
        const derechaStyle = { alignment: { horizontal: "right" }, border };
        // Renglon espejo con lo que el sistema habia calculado antes del ajuste. Va en
        // cursiva gris y NO entra a los subtotales (esos se suman sobre grupo.filas, no
        // sobre las filas del Excel), asi que el papel sigue cuadrando solo.
        const fuenteOriginal = { italic: true, color: { rgb: "999999" }, sz: 10 };
        const originalTextStyle = { font: fuenteOriginal, border };
        const originalMoneyStyle = {
            alignment: { horizontal: "right" },
            numFmt: FORMATO_CONTABILIDAD,
            font: fuenteOriginal,
            border,
        };
        // xlsx-js-style no infiere el tipo de celda cuando ya se le pasa un
        // objeto { v, s } armado - sin "t" explicito, escribe el numero como
        // texto y Excel no puede aplicarle formato de moneda (queda con el
        // triangulo verde de "numero guardado como texto").
        const celdaMoneda = (valor, estilo) => (valor ? { v: valor, t: "n", s: estilo } : { v: "", s: estilo });

        const esMoneda = (col) => col.align === "right" && col.dataIndex !== "proporcion";
        // El total del documento se repetiria en cada pago parcial de la misma
        // factura, por eso queda marcado noSuma y no entra a los subtotales.
        const seSuma = (col) => esMoneda(col) && !col.noSuma;
        const ULTIMA_COLUMNA = COLS_PAPEL.length - 1;
        const COLUMNA_FIN_ETIQUETA = COLS_PAPEL.findIndex((c) => c.dataIndex === "totalDocumento");

        const rows = [];
        const merges = [];

        rows.push([{ v: `PAPEL DE TRABAJO DIOT — ${this.props.empresa || ""}`, s: { font: { bold: true, sz: 14 } } }]);
        merges.push({ s: { r: 0, c: 0 }, e: { r: 0, c: ULTIMA_COLUMNA } });

        rows.push([{ v: `PERIODO: ${this.textoPeriodo()}`, s: { font: { bold: true, sz: 11 } } }]);
        merges.push({ s: { r: 1, c: 0 }, e: { r: 1, c: ULTIMA_COLUMNA } });

        rows.push([]);
        rows.push(COLS_PAPEL.map((col) => ({ v: col.title, s: headerStyle })));

        const filaMovimiento = (r) =>
            COLS_PAPEL.map((col) => {
                const valor = r[col.dataIndex];
                if (esMoneda(col)) return celdaMoneda(valor, moneyStyle);
                if (col.dataIndex === "ajustado") {
                    // Es booleano: sin este caso el String() de abajo escribiria "false".
                    const texto = valor ? "AJUSTADO" : (r.errorCalculo ? "ERROR" : "");
                    return { v: texto, s: textStyle };
                }
                if (col.dataIndex === "fecha") {
                    return { v: valor ? moment(valor).format("DD/MM/YYYY") : "", s: textStyle };
                }
                if (col.dataIndex === "proporcion") {
                    return { v: valor == null ? "" : `${(valor * 100).toFixed(2)}%`, s: derechaStyle };
                }
                return { v: valor == null ? "" : String(valor), s: textStyle };
            });

        // Solo los importes, para dejar ver de donde salio el ajuste.
        const filaCalculoOriginal = (r) =>
            COLS_PAPEL.map((col) => {
                if (esMoneda(col)) return celdaMoneda(r.original?.[col.dataIndex], originalMoneyStyle);
                if (col.dataIndex === "ajustado") {
                    return { v: "cálculo original", s: originalTextStyle };
                }
                return { v: "", s: originalTextStyle };
            });

        const filaTotales = (etiqueta, subconjunto) => {
            const celdas = COLS_PAPEL.map((col) =>
                seSuma(col)
                    ? celdaMoneda(round2Decimals(sumaCampo(subconjunto, col.dataIndex)), totalStyle)
                    : { v: "", s: totalStyle }
            );
            celdas[0] = { v: etiqueta, s: totalEtiquetaStyle };
            return celdas;
        };

        // El backend ya entrega el arreglo ordenado por proveedor y fecha.
        const grupos = [];
        for (const fila of filas) {
            const clave = String(fila.proveedorId);
            let grupo = grupos.find((g) => g.clave === clave);
            if (!grupo) {
                grupo = { clave, nombre: fila.nombreProveedor || "", rfc: fila.rfc || "", filas: [] };
                grupos.push(grupo);
            }
            grupo.filas.push(fila);
        }

        for (const grupo of grupos) {
            const etiqueta = grupo.rfc ? `${grupo.nombre} — RFC: ${grupo.rfc}` : grupo.nombre;
            const bandaIndex = rows.length;
            rows.push(COLS_PAPEL.map((_, i) => ({ v: i === 0 ? etiqueta : "", s: proveedorStyle })));
            merges.push({ s: { r: bandaIndex, c: 0 }, e: { r: bandaIndex, c: ULTIMA_COLUMNA } });

            grupo.filas.forEach((r) => {
                rows.push(filaMovimiento(r));
                if (r.ajustado && r.original) rows.push(filaCalculoOriginal(r));
            });

            const subtotalIndex = rows.length;
            rows.push(filaTotales(`SUBTOTAL ${grupo.nombre}`, grupo.filas));
            merges.push({ s: { r: subtotalIndex, c: 0 }, e: { r: subtotalIndex, c: COLUMNA_FIN_ETIQUETA } });
        }

        const totalIndex = rows.length;
        rows.push(filaTotales("TOTALES GENERALES", filas));
        merges.push({ s: { r: totalIndex, c: 0 }, e: { r: totalIndex, c: COLUMNA_FIN_ETIQUETA } });

        const worksheet = XLSXStyle.utils.aoa_to_sheet(rows);
        worksheet["!merges"] = merges;
        worksheet["!cols"] = COLS_PAPEL.map((col) => {
            if (col.dataIndex === "uuid") return { wch: 38 };
            if (col.dataIndex === "nombreProveedor" || col.dataIndex === "descripcion") return { wch: 30 };
            if (esMoneda(col)) return { wch: 16 };
            return { wch: 15 };
        });
        const workbook = XLSXStyle.utils.book_new();
        XLSXStyle.utils.book_append_sheet(workbook, worksheet, "Papel de Trabajo DIOT");
        XLSXStyle.writeFile(
            workbook,
            `Papel_Trabajo_DIOT_${moment().locale("es").format("DD-MM-YYYY")}.xlsx`
        );
    }

    descargarBatch(){
        this.setState({ loading: true });

        // Formato, agrupacion por RFC y redondeo en armarTxtDiot (layout 2025 del SAT).
        const { texto: batchTexto, avisos } = armarTxtDiot(this.state.dataReporte.diot);
        if (avisos.length > 0) {
            message.warning(`${avisos.length} línea(s) del txt podrían ser rechazadas por el SAT; revisa los avisos del reporte.`);
        }

        // Crear y descargar el archivo .txt
        const nombreArchivo = "reporte_diot";
        const filename = nombreArchivo + ".txt";
        const pom = document.createElement("a");
        const bb = new Blob([batchTexto], { type: "text/plain" });

        pom.setAttribute("href", window.URL.createObjectURL(bb));
        pom.setAttribute("download", filename);
        pom.dataset.downloadurl = ["text/plain", pom.download, pom.href].join(":");
        pom.style.display = "none";
        document.body.appendChild(pom);
        pom.click();
        document.body.removeChild(pom);

        this.setState({ loading: false });
    };

    onFinishFailed(e) {
        ErrorItem(e);
    }

    // El ancla del ajuste: el par pago+factura (o la nota, o la poliza). El backend la
    // vuelve a validar contra empresaId; aqui solo se arma para mandarla.
    anclaDeFila(fila) {
        return {
            origen: fila.origen,
            pagoId: fila.pagoId,
            facturaId: fila.facturaId,
            notaDeCreditoCompraId: fila.notaDeCreditoCompraId,
            polizaId: fila.polizaId,
        };
    }

    // Los importes calculados de ese renglon. Si ya esta ajustado, los calculados son
    // los del snapshot `original`; el renglon en si ya trae los sustituidos.
    calculadoDeFila(fila) {
        if (!fila) return null;
        return fila.ajustado && fila.original ? fila.original : fila;
    }

    // El ajuste vigente reconstruido desde el renglon, para precargar el modal sin otra
    // vuelta al servidor: los importes que trae el renglon YA son los sustituidos.
    ajusteDeFila(fila) {
        if (!fila || !fila.ajustado) return null;
        // El proveedor solo se preselecciona cuando de verdad hubo reasignacion; si no,
        // el campo queda vacio, que es lo que significa "conserva el del movimiento".
        const huboReasignacion = fila.original && fila.original.proveedorId
            && String(fila.original.proveedorId) !== String(fila.proveedorId);
        return {
            ...fila,
            _id: fila.ajusteId,
            motivo: fila.ajusteMotivo,
            proveedorId: huboReasignacion ? fila.proveedorId : undefined,
        };
    }

    cerrarModalAjuste(recargar) {
        this.setState({ modalAjusteVisible: false, filaAjuste: null });
        if (recargar && this.state.ultimaConsulta) {
            this.consultarReporteDIOT(this.state.ultimaConsulta);
        }
    }

    // Columna de accion: solo en pantalla, nunca en el Excel (el export recorre
    // COLS_PAPEL, que no la incluye).
    columnaAccionAjuste() {
        return {
            title: "", key: "accionAjuste", width: 90, fixed: "right",
            render: (valor, fila) => (
                <ButtonItem
                    blanco
                    size="small"
                    onClick={() => this.setState({ modalAjusteVisible: true, filaAjuste: fila })}
                >
                    {fila.ajustado ? "Editar" : "Ajustar"}
                </ButtonItem>
            ),
        };
    }

    // Lo que el SAT rechazaria del txt, con las reglas del instructivo de carga masiva. Se
    // avisa y se deja descargar: corregir es decision del usuario.
    renderAvisoTxtSat() {
        const diot = this.state.dataReporte?.diot || [];
        if (diot.length === 0) return null;
        const { avisos } = armarTxtDiot(diot);
        if (avisos.length === 0) return null;
        return (
            <Alert
                type="warning"
                showIcon
                style={{ marginTop: 10 }}
                message={`${avisos.length} línea(s) del txt podrían ser rechazadas por el SAT`}
                description={
                    <>
                        <div>
                            Revisa estos proveedores antes de presentar. Los datos del tercero (tipo de
                            operación, RFC, ID tributario, país) se corrigen en el catálogo de proveedores;
                            los importes, con un ajuste DIOT.
                        </div>
                        <ul style={{ margin: "4px 0 0 0", paddingLeft: 18 }}>
                            {avisos.map((a) => (
                                <li key={a.linea}>
                                    Línea {a.linea}: {a.proveedor}{a.rfc ? ` (${a.rfc})` : ""} — {a.problemas.join("; ")}
                                </li>
                            ))}
                        </ul>
                    </>
                }
            />
        );
    }

    // El doble conteo clasico: una poliza marcada paraDiot SUMA, y esa misma poliza es
    // la del pago de una factura que ya entro al reporte por su cuenta.
    renderAvisoDuplicados() {
        const duplicados = this.state.dataReporte?.posiblesDuplicados || [];
        if (duplicados.length === 0) return null;
        return (
            <Alert
                type="error"
                showIcon
                style={{ marginTop: 10 }}
                message={`${duplicados.length} poliza(s) podrian estar declarandose dos veces`}
                description={
                    <>
                        <div>
                            Estas polizas estan marcadas para DIOT (lo cual SUMA a la declaracion) y ademas
                            son la poliza del pago de una factura que ya entra al reporte por su cuenta.
                            Si es el mismo IVA, quitales la marca de DIOT y corrige el movimiento del pago
                            con un ajuste, que SUSTITUYE en vez de sumar.
                        </div>
                        <ul style={{ margin: "4px 0 0 0", paddingLeft: 18 }}>
                            {duplicados.map((d) => (
                                <li key={d.polizaId}>
                                    {d.documento} — {d.concepto} — base {dineroDisabledMask(d.diotBaseIva)},
                                    IVA {dineroDisabledMask(d.diotIva)}
                                </li>
                            ))}
                        </ul>
                    </>
                }
            />
        );
    }

    renderAvisoHuerfanos() {
        const noAplicados = this.state.dataReporte?.ajustesNoAplicados || [];
        if (noAplicados.length === 0) return null;

        // Los que solo cambiaron de periodo no son un problema: el ajuste sigue vivo y se
        // aplica en su mes nuevo. Se separan para que la alerta roja signifique algo.
        const rotos = noAplicados.filter((a) => !a.soloInformativo);
        const movidos = noAplicados.filter((a) => a.soloInformativo);

        const detalle = (lista) => (
            <ul style={{ margin: "4px 0 0 0", paddingLeft: 18 }}>
                {lista.map((a) => (
                    <li key={a._id}>
                        {a.descripcionMovimiento || a.claveMovimiento} — {a.motivoNoAplicado}
                    </li>
                ))}
            </ul>
        );

        return (
            <>
                {rotos.length > 0 ? (
                    <Alert
                        type="warning"
                        showIcon
                        style={{ marginTop: 10 }}
                        message={`${rotos.length} ajuste(s) manual(es) quedaron sin aplicarse`}
                        description={
                            <>
                                <div>
                                    El movimiento que corregian ya no entra al reporte, asi que esa correccion
                                    no se esta declarando. Revisalos y vuelve a capturarlos donde corresponda.
                                </div>
                                {detalle(rotos)}
                            </>
                        }
                    />
                ) : null}
                {movidos.length > 0 ? (
                    <Alert
                        type="info"
                        showIcon
                        closable
                        style={{ marginTop: 10 }}
                        message={`${movidos.length} ajuste(s) se aplican en otro periodo`}
                        description={detalle(movidos)}
                    />
                ) : null}
            </>
        );
    }

    // Notas de credito aplicadas a una factura al crearse cuya poliza traspaso el IVA de la
    // nota y no el de la factura. La DIOT ya esta bien; lo que no cuadra es el auxiliar.
    renderAvisoTraspasoNotas() {
        const notas = this.state.dataReporte?.notasConTraspasoIncorrecto || [];
        if (notas.length === 0) return null;
        return (
            <Alert
                type="warning"
                showIcon
                style={{ marginTop: 10 }}
                message={`${notas.length} poliza(s) de nota de credito con el IVA mal traspasado`}
                description={
                    <>
                        <div>
                            La DIOT esta bien; el auxiliar de IVA no. Al aplicar estas notas a su factura,
                            la poliza paso de IVA por pagar a IVA pagado el IVA de la nota en lugar del IVA
                            proporcional de la factura. Haz la poliza de ajuste indicada para que el auxiliar
                            cuadre con la DIOT.
                        </div>
                        <ul style={{ margin: "4px 0 0 0", paddingLeft: 18 }}>
                            {notas.map((n) => {
                                const monto = dineroDisabledMask(Math.abs(n.diferencia));
                                const pagado = n.cuentaPagado || `${n.impuesto} pagado`;
                                const porPagar = n.cuentaPorPagar || `${n.impuesto} por pagar`;
                                const ajuste = n.diferencia > 0
                                    ? `cargo ${pagado} / abono ${porPagar} por ${monto}`
                                    : `abono ${pagado} / cargo ${porPagar} por ${monto}`;
                                return (
                                    <li key={`${n.notaId}-${n.cuentaPagadoId}`}>
                                        {n.poliza} — {n.documento} ({n.proveedor}) → factura(s) {n.facturas.join(", ")}:
                                        {" "}{n.impuesto} registrado {dineroDisabledMask(n.registrado)}, debio ser
                                        {" "}{dineroDisabledMask(n.correcto)}. Ajuste: {ajuste}
                                    </li>
                                );
                            })}
                        </ul>
                    </>
                }
            />
        );
    }

    // Antes/despues de un renglon ajustado. Las etiquetas salen de COLS_PAPEL para no
    // repetirlas, pero las columnas se toman de CAMPOS_COMPARABLES_AJUSTE y no de un
    // filtro por "columna de dinero": `montoPagado` tambien lo es y no viaja en
    // `original`, asi que saldria como una diferencia que no existe.
    renderComparativoFila(fila) {
        const columnas = CAMPOS_COMPARABLES_AJUSTE
            .map((nombre) => COLS_PAPEL.find((col) => col.dataIndex === nombre))
            .filter(Boolean);
        return (
            <div style={{ padding: "4px 8px" }}>
                <Row gutter={8} style={{ fontWeight: 600, fontSize: 12, color: "#8c8c8c" }}>
                    <Col span={8}>Concepto</Col>
                    <Col span={5} style={{ textAlign: "right" }}>Calculado</Col>
                    <Col span={5} style={{ textAlign: "right" }}>Declarado</Col>
                    <Col span={6} style={{ textAlign: "right" }}>Diferencia</Col>
                </Row>
                {columnas.map((col) => {
                    const antes = Number(fila.original?.[col.dataIndex]) || 0;
                    const despues = Number(fila[col.dataIndex]) || 0;
                    const diferencia = round2Decimals(despues - antes);
                    if (antes === 0 && despues === 0) return null;
                    return (
                        <Row gutter={8} key={col.dataIndex} style={{ fontSize: 12 }}>
                            <Col span={8}>{col.title}</Col>
                            <Col span={5} style={{ textAlign: "right", color: "#8c8c8c" }}>
                                {dineroDisabledMask(antes)}
                            </Col>
                            <Col span={5} style={{ textAlign: "right", fontWeight: 600 }}>
                                {dineroDisabledMask(despues)}
                            </Col>
                            <Col span={6} style={{ textAlign: "right", color: diferencia === 0 ? "#8c8c8c" : "#fa8c16" }}>
                                {dineroDisabledMask(diferencia)}
                            </Col>
                        </Row>
                    );
                })}
                {fila.original?.nombreProveedor && fila.original.nombreProveedor !== fila.nombreProveedor ? (
                    <div style={{ marginTop: 6, fontSize: 12 }}>
                        <b>Tercero reasignado:</b> {fila.original.nombreProveedor} → {fila.nombreProveedor}
                    </div>
                ) : null}
                <div style={{ marginTop: 6, fontSize: 12, color: "#8c8c8c" }}>
                    <b>Motivo:</b> {fila.ajusteMotivo || "sin motivo capturado"}
                </div>
            </div>
        );
    }

    renderPapelTrabajo() {
        const data = this.state.dataReporte?.papelTrabajo || [];
        const columnas = this.props.permisoAjusteDiot
            ? [...COLS_PAPEL, this.columnaAccionAjuste()]
            : COLS_PAPEL;
        return (
            <Collapse style={{ marginTop: 10 }}>
                <Panel header="Papel de trabajo — Desglose por factura" key="papelTrabajo">
                    <Space style={{ marginBottom: 10 }}>
                        <ButtonItem
                            blanco
                            size="small"
                            icon={<FileExcelOutlined />}
                            onClick={() => this.descargarPapelTrabajo()}
                        >
                            Excel
                        </ButtonItem>
                    </Space>
                    {/* Se usa Table de antd y no TableItem porque TableItem fija su propio
                        scroll y descarta el que se le pase: con 25 columnas la tabla
                        quedaria comprimida sin scroll horizontal. */}
                    <Table
                        className="custom-small-table"
                        locale={localeTable}
                        size="small"
                        columns={columnas}
                        // Un mismo pago puede cubrir varias facturas y una misma factura
                        // recibir varios pagos: ningun id suelto es unico por renglon. La
                        // `clave` que manda el backend (el ancla del movimiento) si lo es,
                        // y es la misma con la que se guarda el ajuste.
                        dataSource={data.map((r, i) => ({ ...r, key: r.clave || i }))}
                        expandable={{
                            rowExpandable: (r) => !!(r.ajustado && r.original),
                            expandedRowRender: (r) => this.renderComparativoFila(r),
                        }}
                        rowClassName={(record, index) =>
                            record.ajustado ? "fila-ajustada" : (index % 2 === 0 ? "zebra-gris" : "default")
                        }
                        pagination={{
                            defaultPageSize: 25,
                            showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} movimientos`,
                        }}
                        scroll={{ x: "max-content" }}
                        summary={() => {
                            if (data.length === 0) return null;
                            // La fila de totales tiene que recorrer las MISMAS columnas que
                            // la tabla (`columnas`, no COLS_PAPEL) y llevar ademas una celda
                            // al frente por la columna que antd agrega para el expandible:
                            // con una celda de menos, los importes se recorren una columna.
                            return (
                                <Table.Summary.Row>
                                    <Table.Summary.Cell key="expand" index={0} />
                                    {columnas.map((col, idx) => {
                                        const indice = idx + 1;
                                        if (idx === 0) {
                                            return (
                                                <Table.Summary.Cell key={col.key} index={indice}>
                                                    <b>TOTAL</b>
                                                </Table.Summary.Cell>
                                            );
                                        }
                                        if (col.align !== "right" || col.noSuma) {
                                            return <Table.Summary.Cell key={col.key || col.dataIndex} index={indice} />;
                                        }
                                        const total = sumaCampo(data, col.dataIndex);
                                        const esControl =
                                            col.dataIndex === "valorActos" ||
                                            col.dataIndex === "ivaAcreditable" ||
                                            col.dataIndex === "ivaNoAcreditable";
                                        return (
                                            <Table.Summary.Cell key={col.key} index={indice} align="right">
                                                <span style={{ fontWeight: esControl ? 700 : 600 }}>
                                                    {dineroDisabledMask(total)}
                                                </span>
                                            </Table.Summary.Cell>
                                        );
                                    })}
                                </Table.Summary.Row>
                            );
                        }}
                    />
                </Panel>
            </Collapse>
        );
    }

    render() {
        const columns = [
            {
                title: "#",
                render: (value, record, index) => (index + 1).toString(),
            },
            {
                title: "Proveedor",
                dataIndex: "nombreProveedor",
                key: "nombreProveedor",
                sorter: (a, b) => {
                    if (a.nombreProveedor < b.nombreProveedor) {
                        return -1;
                    }
                    if (a.nombreProveedor > b.nombreProveedor) {
                        return 1;
                    }
                    return 0;
                },
                buscar: "nombreProveedor",
                ellipsis: true,
            },
            {
                title: "Tipo Tercero",
                dataIndex: "tipoTercero",
                key: "tipoTercero",
                sorter: (a, b) => {
                    if (a.tipoTercero < b.tipoTercero) {
                        return -1;
                    }
                    if (a.tipoTercero > b.tipoTercero) {
                        return 1;
                    }
                    return 0;
                },
                buscar: "tipoTercero",
                ellipsis: true,
            },
            {
                title: "Tipo Operacion",
                dataIndex: "tipoOperacion",
                key: "tipoOperacion",
                sorter: (a, b) => {
                    if (a.tipoOperacion < b.tipoOperacion) {
                        return -1;
                    }
                    if (a.tipoOperacion > b.tipoOperacion) {
                        return 1;
                    }
                    return 0;
                },
                buscar: "tipoOperacion",
                ellipsis: true,
            },
            {
                title: "Valor Actos",
                dataIndex: "valorActos",
                key: "valorActos",
                sorter: (a, b) => {
                    if (a.valorActos < b.valorActos) {
                        return -1;
                    }
                    if (a.valorActos > b.valorActos) {
                        return 1;
                    }
                    return 0;
                },
                buscar: "valorActos",
                align: "right",
                render: (value) => dineroDisabledMask(value),
                ellipsis: true,
            },
            {
                title: "IVA Acreditable",
                dataIndex: "ivaAcreditable",
                key: "ivaAcreditable",
                sorter: (a, b) => {
                    if (a.ivaAcreditable < b.ivaAcreditable) {
                        return -1;
                    }
                    if (a.ivaAcreditable > b.ivaAcreditable) {
                        return 1;
                    }
                    return 0;
                },
                buscar: "ivaAcreditable",
                align: "right",
                render: (value) => dineroDisabledMask(value),
                ellipsis: true,
            },
            {
                title: "IVA no acreditable",
                dataIndex: "ivaNoAcreditable",
                key: "ivaNoAcreditable",
                sorter: (a, b) => {
                    if (a.ivaNoAcreditable < b.ivaNoAcreditable) {
                        return -1;
                    }
                    if (a.ivaNoAcreditable > b.ivaNoAcreditable) {
                        return 1;
                    }
                    return 0;
                },
                buscar: "ivaNoAcreditable",
                align: "right",
                render: (value) => dineroDisabledMask(value),
                ellipsis: true,
            },
            {
                title: "IVA Retenido",
                dataIndex: "ivaRetenido",
                key: "ivaRetenido",
                sorter: (a, b) => {
                    if (a.ivaRetenido < b.ivaRetenido) {
                        return -1;
                    }
                    if (a.ivaRetenido > b.ivaRetenido) {
                        return 1;
                    }
                    return 0;
                },
                buscar: "ivaRetenido",
                align: "right",
                render: (value) => dineroDisabledMask(value),
                ellipsis: true,
            },
        ];
        return (
            <>
                <Form
                    ref={this.formRef}
                    name="reporteDIOT"
                    onFinish={this.consultarReporteDIOT.bind(this)}
                    onFinishFailed={this.onFinishFailed}
                    initialValues={{
                        tipoReporte: 1,
                        fechaReporte: moment(),
                    }}
                >
                    <PageHeader
                        onBack={this.atras.bind(this)}
                        title="Reporte DIOT"
                        style={{
                            border: "1px solid rgb(235, 237, 240)",
                            backgroundColor: "white",
                            marginBottom: 10,
                        }}
                        extra={
                            <div style={{ display: "flex", justifyContent: "right" }}>
                                <Space>
                                    {this.state.dataReporte && (
                                        <ButtonItem
                                            blanco
                                            onClick={() => this.descargarBatch()}
                                            icon={<FileTextOutlined />}
                                            style={{ display: "block", margin: "0 0 0 auto" }}
                                        >
                                            Descargar BATCH
                                        </ButtonItem>
                                    )}
                                    {this.state.dataReporte && (
                                        <ButtonItem
                                            blanco
                                            onClick={() => this.descargarExcel()}
                                            icon={<FileExcelOutlined />}
                                            style={{ display: "block", margin: "0 0 0 auto" }}
                                        >
                                            Descargar Excel
                                        </ButtonItem>
                                    )}
                                    {this.state.dataReporte && (
                                        <ButtonItem
                                            blanco
                                            onClick={() => this.descargarPdf()}
                                            icon={<FilePdfOutlined />}
                                            style={{ display: "block", margin: "0 0 0 auto" }}
                                        >
                                            Descargar PDF
                                        </ButtonItem>
                                    )}
                                    {this.state.dataReporte && (
                                        <ButtonItem
                                            blanco
                                            onClick={() => this.descargarPapelTrabajo()}
                                            icon={<FileExcelOutlined />}
                                            style={{ display: "block", margin: "0 0 0 auto" }}
                                        >
                                            Papel de Trabajo
                                        </ButtonItem>
                                    )}
                                    <ButtonItem
                                        type="primary"
                                        htmlType="submit"
                                        style={{ display: "block", margin: "0 0 0 auto" }}
                                    >
                                        Consultar
                                    </ButtonItem>
                                </Space>
                            </div>
                        }
                    />
                    <Spin spinning={this.state.loading}>
                        <div
                            style={{
                                backgroundColor: "white",
                                padding: 20,
                                paddingTop: 5,
                                borderRadius: 5,
                                boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
                            }}
                        >
                            <Tabs
                                style={{ margin: 0 }}
                                tabBarExtraContent={{
                                    left: (
                                        <h1 style={{ padding: 0, margin: "0 10px 0 0" }}>
                                            Filtros:
                                        </h1>
                                    ),
                                }}
                            >
                                <TabPane tabKey="4" key="4" forceRender tab="Periodo">
                                    <Row>
                                        <Col span={8}>
                                            <FormItem
                                                name="tipoReporte"
                                                required
                                                noStyle
                                                initialValue={1}
                                            >
                                                <SelectItem width="90%" placeholder="Tipo Reporte">
                                                    <Option default value={1}>Mensual</Option>
                                                    <Option value={2}>Semestral</Option>
                                                </SelectItem>
                                            </FormItem>
                                        </Col>
                                        <Col span={8}>
                                            <FormItem shouldUpdate noStyle>
                                                {({ getFieldValue }) => {
                                                    const tipoReporte =
                                                        getFieldValue("tipoReporte");
                                                    if (tipoReporte === 1) {
                                                        return (
                                                            <FormItem name="fechaReporte" required noStyle>
                                                                <DatePickerItem format="MMMM" picker="month" disabledDate={(current) => {
                                                                    return current < moment("2025-01-01", "YYYY-MM-DD");
                                                                }} />
                                                            </FormItem>
                                                        );
                                                    }
                                                    if (tipoReporte === 2) {
                                                        return (
                                                            <FormItem name="periodo" required noStyle>
                                                                <RangePickerItem />
                                                            </FormItem>
                                                        );
                                                    }
                                                }}
                                            </FormItem>
                                        </Col>
                                    </Row>
                                </TabPane>
                            </Tabs>
                        </div>
                        <TableItem
                            rowKey={(value) => value.proveedorId.toString()}
                            columns={columns}
                            dataSource={this.state.dataReporte?.diot || []}
                            size="small"
                            pagination={false}
                        />
                        {this.renderAvisoTxtSat()}
                        {this.renderAvisoDuplicados()}
                        {this.renderAvisoHuerfanos()}
                        {this.renderAvisoTraspasoNotas()}
                        {this.renderPapelTrabajo()}
                    </Spin>
                </Form>
                <ModalAjusteDiot
                    visible={this.state.modalAjusteVisible}
                    ancla={this.state.filaAjuste ? this.anclaDeFila(this.state.filaAjuste) : {}}
                    calculado={this.calculadoDeFila(this.state.filaAjuste)}
                    ajuste={this.ajusteDeFila(this.state.filaAjuste)}
                    errorCalculo={this.state.filaAjuste?.errorCalculo}
                    descripcionMovimiento={this.state.filaAjuste
                        ? `${this.state.filaAjuste.tipoMovimiento} — ${this.state.filaAjuste.documento || ''} — ${this.state.filaAjuste.nombreProveedor || ''}`
                        : ''}
                    onCancel={() => this.cerrarModalAjuste(false)}
                    onGuardado={() => this.cerrarModalAjuste(true)}
                />
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
        empresaId: state.empresa.id,
        empresa: state.empresa.nombre,
        // Mismo permiso que gatea el modal DIOT de Ver Poliza: es el mismo privilegio
        // (intervenir a mano la DIOT), asi que no se da de alta uno nuevo.
        permisoAjusteDiot: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "615cea8ff30e81b54183cfbf")?.activado,
    };
};

export default connect(mapStateToProps)(ReporteDIOT);
